<template>
  <div id="lm-event">
    <LmSelect
      v-model="optionSelected"
      :options="options"
    />
  </div>
</template>

<script>
import LmSelect from '@/components/form/elements/LmSelect'
export default {
  data () {
    return {
      optionSelected: ''
    }
  },
  props: {
    options: {
      type: Object,
      default: () => ({
        disabledOption: 'Please select an option',
        content: []
      })
    }
  },
  components: {
    LmSelect
  }

}
</script>
